import type { AdminNamespace } from '@cli-types/next-adapter/config.js'

export function replaceAdminDashToken(value: string, namespace: AdminNamespace): string {
  return value.replaceAll('admin-', `${namespace.segment}-`)
}
